


















import { Component, Vue } from 'vue-property-decorator';
import AsLoginForm from './components/asLoginForm.vue';
import { TagsViewModule } from '@/store/modules/tagsView';


@Component({
  components: {
    AsLoginForm,
  },
})
export default class Login extends Vue {
  private loginedCallBack() {
    let redirect: string = '/';
    if (this.$route.query.redirect) {
      redirect = this.$route.query.redirect as string;
    }
    this.$router.push(redirect);
  }
  private created() {
    TagsViewModule.DelAllViews();
  }
}
